import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    ReservationFamilyComponent,
    ReservationFamilyCreateComponent,
    ReservationFamilyDetailComponent,
    reservationFamilyPopupRoute,
    reservationFamilyRoute,
    ReservationFamilyResolvePagingParams,
    ReservationFamilyService,
    ReservationFamilyPopupService,
    ReservationFamilyDeletePopupComponent,
    ReservationFamilyDeleteDialogComponent,
} from '.';

let ENTITY_STATES = [
    ...reservationFamilyRoute,
    ...reservationFamilyPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ReservationFamilyComponent,
        ReservationFamilyCreateComponent,
        ReservationFamilyDetailComponent,
        ReservationFamilyDeletePopupComponent,
        ReservationFamilyDeleteDialogComponent,
    ],
    entryComponents: [
        ReservationFamilyComponent,
        ReservationFamilyDeletePopupComponent,
        ReservationFamilyDeleteDialogComponent,
    ],
    providers: [
        ReservationFamilyResolvePagingParams,
        ReservationFamilyService,
        ReservationFamilyDeletePopupComponent,
        ReservationFamilyPopupService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiRecurrentReservationModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/reservation-family.module.ts